<template>

<div>

<div v-if='!projectPhase.user_id'>
    <div class="alert alert-info">
        Подаването на оферти за този етап е приключило. Следва възложителят да посочи победител.
    </div>
    
    <div id="winner" class="col-12 mb-4 p-4 bg-light-green">
        <div class="row d-flex align-items-center">
            <div class="col-4 text-center">
                <span class="icon icon-cup"></span>
            </div> 

            <div class="col-8 pl-0">
                <h4>Възложителят все още не е избрал победител в този етап.</h4>
            </div>
        </div>
    </div>
</div>

<div v-if='projectPhase.user_id'>
    
    <div v-if='projectPhase.user_id == user.id'>
       
        <auction-winner v-if='phase.type == "auction"'></auction-winner>            
        <competition-winner v-if='phase.type == "competition"'></competition-winner> 

    </div>

    <div v-else>

        <winner-info v-if='isReady && !access'></winner-info>

        <div v-if='isReady && access'>

            <div class='col-12 alert alert-success'>
                Имате достъп до контрола върху изпълнението на този етап.
            </div>

            <auction-winner></auction-winner>

            <br/>
            
            <worker-review :pp='projectPhase'></worker-review>
            

        </div>

    </div>

</div>


</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
            if ( typeof this.pp == 'object' ) {
                this.projectPhase = this.pp;
            }

            if( this.projectPhase.user_id != this.user.id ) {
                this.checkAccess();
            }
        },

        props : ['pp'],

        data() {

            return {

                phase        : this.$parent.$parent.phase,
                projectPhase : this.$parent.$parent.projectPhase,
                project      : this.$parent.$parent.model,

                //Does the current user have access to control the phase
                access : false,

                isReady : false,

            }

        },

        methods : {

            checkAccess() {
                var me = this;

                me.ajax.call("auc:chac", { pp : this.projectPhase.id }, (r) => {
                  
                    if( r.status == 'success' ) {
                       
                        if( r.data == 1 ) {
                            me.access = true;
                        }

                        me.isReady = true;

                    }

                })
            }

        },

        components : {
            'control-phase'        : require('./ControlPhase.vue').default,
            'auction-winner'        : require('./AuctionWinner.vue').default,
            'competition-winner'    : require('./CompetitionWinner.vue').default,
            'winner-info'           : require('./WinnerInfo.vue').default
        }

    }
</script>
